import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../../../../shared/services/language.service';
import { Report } from '../../../../admin/report/report';
import { StatmentReportService } from '../../services/fetch-statment-report.service';

@Component({
  selector: 'app-statement',
  templateUrl: './statement.component.html',
  styleUrls: ['./statement.component.scss']
})
export class StatementComponent implements OnInit {
  reportName="";
  tableColumns: string[] = [
    'createdAt',
    'transactionType',
    'amount',
    'CumulativeSum',
    'refNumber'
  ];

  displayTableColumns = {};
  filterField = [];
  totalNumberOfRecords: number = 0;
  statementReportData: any[] = [];
  requestBody: Report = {};
  loading: boolean = false;

  constructor(
    public statmentReportService: StatmentReportService,
    private translate: TranslateService,
    private languageService: LanguageService
  ) { }

  async ngOnInit() {
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        this.loadArContent();
      } else if (localStorage.getItem("language") === "en") {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === "ar") {
        this.loadArContent();
      } else if (lang === "en") {
        this.loadEnContent();
      }
    });
    this.statmentReportService.activateLoader();
    this.updateTable();
  }

  loadArContent() {
    this.reportName = 'تقرير الافاده';
    this.translate.use('ar');

    this.displayTableColumns = {
      createdAt: 'التاريخ',
      transactionType: 'نوع المعاملة',
      amount: 'المبلغ',
      CumulativeSum: 'الحساب',
      refNumber: 'الرقم المرجعي للمعاملة',
    };
  }

  loadEnContent() {
    this.reportName = 'Statement Report';
    this.translate.use('en');

    this.displayTableColumns = {
      createdAt: 'Date',
      transactionType: 'Transaction Type',
      amount: 'Amount',
      CumulativeSum: 'Balance',
      refNumber: 'Transaction Refernce Number',
    };
  }

  async filter($event: any) {
    if ($event && Object.keys($event).length) {
      this.requestBody.filterOptions = $event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.statmentReportService.loader().subscribe((val: any) => this.loading = val);
  }

  async paginate($event: any) {
    this.requestBody.paginationOptions = {
      start: $event.pageIndex * $event.pageSize,
      limit: $event.pageSize
    };
    this.updateTable();
    this.statmentReportService.loader().subscribe((val: any) => this.loading = val);
  }

  async searchChance($event: any) {
    if ($event) {
      this.requestBody.searchOptions = {
        searchKey: $event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.statmentReportService.loader().subscribe((val: any) => this.loading = val);
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.statmentReportService.loader().subscribe((val: any) => this.loading = val);
  }

  async updateTable() {
    this.statmentReportService.activateLoader();
    this.statmentReportService.setParams(this.requestBody);
    const report = await this.statmentReportService.make();
    this.statementReportData = report.result;
    this.totalNumberOfRecords = report.totalNumberOfRows;
  }
}
